import React from 'react';
import PropTypes from 'prop-types';

import { STATIC_ROOT } from '../../../../constants';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import ButtonComponent from '../../../button/ButtonComponent';

const KycBloc = ({ i18n, onStart }) => (
    <div className="conteneur-color kyc">
        <p>{convertHtmlToReactDomWithParams(i18n.TEXT_KYC_1)}</p>
        <ButtonComponent color="main" text={i18n.TEXT_KYC_BUTTON_TEXT} onClick={onStart} />

        <p className="info">{convertHtmlToReactDomWithParams(i18n.TEXT_KYC_2)}</p>
        <div className="ubble">
            <div>{i18n.TEXT_KYC_3}</div>
            <div>
                <img
                    src={`${STATIC_ROOT}/kyc/ubble.png`}
                    alt="Ubble logo"
                    width="100"
                    height="37"
                />
            </div>
        </div>
    </div>
);

KycBloc.propTypes = {
    i18n: PropTypes.object.isRequired,
    onStart: PropTypes.func.isRequired
};

export default KycBloc;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/KycBloc.js